/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ChangePasswordCreatePayload,
  CompanyType,
  ForgotPasswordCreatePayload,
  LoginCreateParams,
  LoginCreatePayload,
  RefreshTokenCreatePayload,
  ResetPasswordCreatePayload,
  TotpDisableCreatePayload,
  TotpEnableCreatePayload,
  TotpLoginCreatePayload,
  TotpSetupCreatePayload,
  UserGroupName,
} from "./api";
import { ContentType, HttpClient, RequestParams } from "./httpClient";

export class Auth<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Return the user that is currently logged in
   *
   * @tags Auth
   * @name GetAuth
   * @summary Get me
   * @request GET:/auth/me
   * @secure
   */
  getAuth = (params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        uid: string;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
        fullName?: string;
        language?: string;
        country?: string | null;
        phone?: string | null;
        isBlocked: boolean;
        isSuperAdmin: boolean;
        invitationConfirmed: boolean;
        groups?: UserGroupName[];
        company?: {
          uid: string;
          /** @format company-type-enum */
          companyType: CompanyType;
          name: string;
          address: string;
          postCode: string;
          city: string;
          country: string;
          website: string;
          phone: string;
          fax?: string | null;
          invoiceAddress: string;
          invoicePostCode: string;
          invoiceCity: string;
          invoiceCountry: string;
          vat: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt: Date;
          carrierDetails?: {
            accountDebit: string;
            accountCredit: string;
            contact: string;
            scac: string;
            oblLength: number | null;
          };
          memberDetails?: {
            eori: string;
            membershipNumber: string;
            osaAccountNumber: string;
            onmiAccountNumber: string;
            osaMember: boolean;
            ossiMember: boolean;
            affiliateOffice: boolean;
          };
          /** @default false */
          fromPortal?: boolean;
        };
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        updatedAt: Date;
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/auth/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Attempt to log in the user with given credentials
   *
   * @tags Auth
   * @name LoginCreate
   * @summary Login user
   * @request POST:/auth/login
   * @secure
   */
  loginCreate = (query: LoginCreateParams, data: LoginCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        id?: string | null;
        token?: string | null;
        refreshToken?: string | null;
        isBlocked?: boolean;
        email: string;
        company?: {
          uid: string;
          /** @format company-type-enum */
          companyType: CompanyType;
          name: string;
          address: string;
          postCode: string;
          city: string;
          country: string;
          website: string;
          phone: string;
          fax?: string | null;
          invoiceAddress: string;
          invoicePostCode: string;
          invoiceCity: string;
          invoiceCountry: string;
          vat: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt: Date;
          carrierDetails?: {
            accountDebit: string;
            accountCredit: string;
            contact: string;
            scac: string;
            oblLength: number | null;
          };
          memberDetails?: {
            eori: string;
            membershipNumber: string;
            osaAccountNumber: string;
            onmiAccountNumber: string;
            osaMember: boolean;
            ossiMember: boolean;
            affiliateOffice: boolean;
          };
          /** @default false */
          fromPortal?: boolean;
        };
        groups?: string[];
        mfaRequired: boolean;
        mfaToken?: string | null;
        totpEnabled: boolean;
        /** @format date-time */
        createdAt?: Date | null;
        /** @format date-time */
        updatedAt?: Date | null;
      },
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/login`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Complete login using a short-lived MFA challenge and a TOTP code
   *
   * @tags Auth
   * @name TotpLoginCreate
   * @summary Complete TOTP login
   * @request POST:/auth/totp/login
   * @secure
   */
  totpLoginCreate = (data: TotpLoginCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        id?: string | null;
        token?: string | null;
        refreshToken?: string | null;
        isBlocked?: boolean;
        email: string;
        company?: {
          uid: string;
          /** @format company-type-enum */
          companyType: CompanyType;
          name: string;
          address: string;
          postCode: string;
          city: string;
          country: string;
          website: string;
          phone: string;
          fax?: string | null;
          invoiceAddress: string;
          invoicePostCode: string;
          invoiceCity: string;
          invoiceCountry: string;
          vat: string;
          /** @format date-time */
          deactivatedAt?: Date;
          /** @format date-time */
          archivedAt?: Date;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt: Date;
          carrierDetails?: {
            accountDebit: string;
            accountCredit: string;
            contact: string;
            scac: string;
            oblLength: number | null;
          };
          memberDetails?: {
            eori: string;
            membershipNumber: string;
            osaAccountNumber: string;
            onmiAccountNumber: string;
            osaMember: boolean;
            ossiMember: boolean;
            affiliateOffice: boolean;
          };
          /** @default false */
          fromPortal?: boolean;
        };
        groups?: string[];
        mfaRequired: boolean;
        mfaToken?: string | null;
        totpEnabled: boolean;
        /** @format date-time */
        createdAt?: Date | null;
        /** @format date-time */
        updatedAt?: Date | null;
      },
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/totp/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Return whether TOTP is enabled for the authenticated user
   *
   * @tags Auth
   * @name TotpStatusList
   * @summary Get TOTP status
   * @request GET:/auth/totp/status
   * @secure
   */
  totpStatusList = (params: RequestParams = {}) =>
    this.request<
      {
        enabled: boolean;
        /** @format date-time */
        enabledAt?: Date | null;
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/auth/totp/status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate a TOTP setup challenge after confirming the current password
   *
   * @tags Auth
   * @name TotpSetupCreate
   * @summary Start TOTP setup
   * @request POST:/auth/totp/setup
   * @secure
   */
  totpSetupCreate = (data: TotpSetupCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        setupToken: string;
        /**
         * otpauth:// URI used by authenticator apps
         * @format uri
         */
        otpauthUri: string;
        secret: string;
        issuer: string;
        /** @format email */
        email: string;
      },
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/totp/setup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Enable TOTP after verifying the setup challenge code
   *
   * @tags Auth
   * @name TotpEnableCreate
   * @summary Enable TOTP
   * @request POST:/auth/totp/enable
   * @secure
   */
  totpEnableCreate = (data: TotpEnableCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        enabled: boolean;
        /** @format date-time */
        enabledAt?: Date | null;
      },
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/totp/enable`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Disable TOTP after confirming the current password and a current TOTP code
   *
   * @tags Auth
   * @name TotpDisableCreate
   * @summary Disable TOTP
   * @request POST:/auth/totp/disable
   * @secure
   */
  totpDisableCreate = (data: TotpDisableCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        enabled: boolean;
        /** @format date-time */
        enabledAt?: Date | null;
      },
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/totp/disable`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description The current user's high-level privileges (e.g. which menu items to show)
   *
   * @tags Auth
   * @name PrivilegesList
   * @summary Logged-in user high-level privileges
   * @request GET:/auth/privileges
   * @secure
   */
  privilegesList = (params: RequestParams = {}) =>
    this.request<
      {
        privileges?: string[];
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/auth/privileges`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Refresh user authentication token
   *
   * @tags Auth
   * @name RefreshTokenCreate
   * @summary Refresh Token
   * @request POST:/auth/refresh-token
   * @secure
   */
  refreshTokenCreate = (data: RefreshTokenCreatePayload, params: RequestParams = {}) =>
    this.request<
      {
        token?: string;
      },
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/auth/refresh-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Start the forgot password process
   *
   * @tags Auth
   * @name ForgotPasswordCreate
   * @summary Send the forgot password email
   * @request POST:/auth/forgot-password
   * @secure
   */
  forgotPasswordCreate = (data: ForgotPasswordCreatePayload, params: RequestParams = {}) =>
    this.request<
      void,
      {
        /** Error message */
        message?: string;
        /** Object containing validation errors */
        data?: object;
      }
    >({
      path: `/auth/forgot-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Reset the password using the token retrieved from forgot-pass action
   *
   * @tags Auth
   * @name ResetPasswordCreate
   * @summary Reset the password
   * @request POST:/auth/reset-password
   * @secure
   */
  resetPasswordCreate = (data: ResetPasswordCreatePayload, params: RequestParams = {}) =>
    this.request<
      void,
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Changes the password of an authenticated user using the old and new password
   *
   * @tags Auth
   * @name ChangePasswordCreate
   * @summary Changes the password
   * @request POST:/auth/change-password
   * @secure
   */
  changePasswordCreate = (data: ChangePasswordCreatePayload, params: RequestParams = {}) =>
    this.request<
      void,
      | {
          /** Error message */
          message?: string;
        }
      | {
          /** Error message */
          message?: string;
          /** Object containing validation errors */
          data?: object;
        }
    >({
      path: `/auth/change-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Invite user to the platform
   *
   * @tags User
   * @name InviteUpdate
   * @summary Invite user
   * @request PUT:/auth/{userUid}/invite
   * @secure
   */
  inviteUpdate = (userUid: string, params: RequestParams = {}) =>
    this.request<
      void,
      {
        /** Error message */
        message?: string;
      }
    >({
      path: `/auth/${userUid}/invite`,
      method: "PUT",
      secure: true,
      ...params,
    });
}
